import React, { Component } from 'react';
import PropTypes from 'prop-types'

import { BASE_URL } from '../config'
import { PootsyButton } from './DesignFunctions'
import pootsyLogo from '../static/img/pootsy-logo.png'

class DownloadAppsPrompt extends Component {
	render() {
		let { t } = this.context
		let link = "#"
		// if (/windows phone/i.test(navigator.userAgent)) {
		// }
		if (/android/i.test(navigator.userAgent)) {
			link = "https://play.google.com/store/apps/details?id=be.pootsy.customer"
		}
		// iOS detection from: http://stackoverflow.com/a/9039885/177710
		if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
			link = "https://itunes.apple.com/be/app/pootsy/id1205673280"
		}
		return (
			<div className="DownloadAppsPrompt">
				<a href={BASE_URL}>
					<img className="logo" alt="logo" src={pootsyLogo}/>
				</a>
				<div className="prompt">{t("download_app_prompt")}</div>
				<a href={link}>
					<PootsyButton text={t('click_here_to_download_app')}/>
				</a>
			</div>
		);
	}
}

DownloadAppsPrompt.contextTypes = { t: PropTypes.func }
export default DownloadAppsPrompt;



// WEBPACK FOOTER //
// ./src/components/DownloadAppsPrompt.js